import { Palette } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { applyTheme, THEMES, useThemeStore } from '@/stores/theme';

export function AjustesTemaPage() {
  const { t } = useTranslation();
  const theme = useThemeStore((s) => s.theme);
  const setTheme = useThemeStore((s) => s.setTheme);

  function onSelectTheme(id: (typeof THEMES)[number]['id']) {
    setTheme(id);
    applyTheme(id);
  }

  return (
    <main className="container mx-auto max-w-2xl px-4">
      <h1 className="mb-4 flex items-center gap-2 text-xl font-bold text-text-primary">
        <Palette className="h-5 w-5 text-accent-icon" aria-hidden />
        {t('ajustes.tema')}
      </h1>
      <section className="rounded-lg border border-border bg-surface p-4">
        <div className="space-y-2" role="radiogroup" aria-label={t('ajustes.tema')}>
          {THEMES.map(({ id, label, description }) => {
            const activo = theme === id;
            return (
              <button
                key={id}
                type="button"
                role="radio"
                aria-checked={activo}
                data-testid={`tema-${id}`}
                onClick={() => onSelectTheme(id)}
                className={`flex w-full items-center justify-between rounded-md border px-3 py-2.5 text-left transition-colors ${activo ? 'border-accent bg-accent/10 text-accent' : 'border-border text-text-primary hover:bg-background'}`}
              >
                <span className="flex flex-col">
                  <span className="text-sm font-medium">{t(label)}</span>
                  <span className="text-xs text-text-secondary">{t(description)}</span>
                </span>
                {activo && <span className="h-2.5 w-2.5 rounded-full bg-accent" aria-hidden />}
              </button>
            );
          })}
        </div>
      </section>
    </main>
  );
}
